import { createContext, useContext, useEffect, useState } from "react";

export const translations = {
  pt: {
    nav: { home: "Início", bots: "Nossos Bots", products: "Novos Produtos", contact: "Contato" },
    hero: {
      badge: "SISTEMAS NAVX // ONLINE",
      line1: "Soluções",
      line2: "Inteligentes &",
      line3: "Bots Inovadores",
      subtitle:
        "Desenvolvemos automações, inteligência artificial e sistemas customizados que colocam o seu negócio no próximo nível.",
      ctaWhatsapp: "Fale Conosco pelo WhatsApp",
      ctaBots: "Explorar Bots",
      stats: [
        { value: "6+", label: "Bots Ativos" },
        { value: "24/7", label: "Uptime" },
        { value: "<100ms", label: "Resposta" },
      ],
      scroll: "Role para explorar",
    },
    marquee: ["BOTS", "AUTOMAÇÃO", "INTELIGÊNCIA ARTIFICIAL", "SISTEMAS CUSTOMIZADOS", "NAVX", "WHATSAPP API", "GAMES"],
    manifesto: {
      label: "MANIFESTO",
      title: "Engenharia com assinatura própria",
      chapters: [
        {
          num: "01",
          title: "Automação",
          text: "Fluxos de trabalho inteiros rodando sozinhos. Bots que atendem, moderam, vendem e operam enquanto você foca no que importa.",
        },
        {
          num: "02",
          title: "Inteligência Artificial",
          text: "Agentes de IA com respostas naturais, memória de contexto e integração profunda com as suas ferramentas do dia a dia.",
        },
        {
          num: "03",
          title: "Sistemas Sob Medida",
          text: "Do conceito ao deploy: plataformas, APIs e jogos desenhados para a sua necessidade exata — sem template, sem atalho.",
        },
      ],
    },
    bots: {
      label: "PORTFÓLIO",
      title: "Nossos Bots",
      subtitle: "Assistentes autônomos e sistemas inteligentes criados com a assinatura de excelência NavX.",
      byBadge: "By: NavX",
      learnMore: "Saber Mais",
      addBot: "Adicionar Bot",
      status: "ONLINE",
      inquiry: "Olá, NavX! Quero saber mais sobre o bot",
      list: [
        { id: "naty", name: "Naty", role: "MODERAÇÃO", desc: "Moderadora chefe. Anti-spam, anti-link, boas-vindas personalizadas e gestão completa de grupos.", art: "naty" },
        { id: "hano", name: "Hano", role: "ENTRETENIMENTO", desc: "Diversão garantida: mini-jogos, economia virtual e RPG de texto dentro do seu grupo.", art: null },
        { id: "zora", name: "Zora Bot", role: "ATENDIMENTO IA", desc: "Atendimento inteligente 24/7. Responde clientes, agenda horários e qualifica leads sozinha.", art: null },
        { id: "momo", name: "Momo", role: "UTILIDADES", desc: "Canivete suíço dos bots: figurinhas, downloads, consultas e dezenas de utilidades rápidas.", art: "momo" },
        { id: "madara", name: "Madara", role: "RPG / ANIME", desc: "RPG de batalhas inspirado em anime. Evolua personagens, duele e domine o ranking do servidor.", art: null },
        { id: "aizen", name: "Aizen", role: "IA AVANÇADA", desc: "IA conversacional avançada com comandos inteligentes, memória e respostas naturais.", art: "aizen" },
      ],
    },
    products: {
      label: "LABORATÓRIO",
      title: "Novos Produtos",
      subtitle: "Os próximos lançamentos e soluções de tecnologia que estão nascendo dentro do ecossistema NavX.",
      gameTitle: "NavX Game — Projeto em Produção",
      gameDesc:
        "Nosso primeiro jogo está sendo produzido neste exato momento. Uma experiência com a identidade pixel que é a cara da NavX. Confira um vislumbre real do desenvolvimento.",
      statusProduction: "EM PRODUÇÃO",
      statusSoon: "EM BREVE",
      statusLaunch: "LANÇAMENTO",
      watchNow: "Assistir agora",
      others: [
        { id: "api", name: "NavX Cloud API", desc: "Infraestrutura de bots como serviço: hospede, escale e monitore seus bots em um painel único.", status: "soon" },
        { id: "engine", name: "Bot Engine 2.0", desc: "A nova geração do motor NavX: comandos por voz, IA generativa nativa e plugins da comunidade.", status: "launch" },
      ],
    },
    contact: {
      label: "CONTATO",
      title: "Fale com a NavX",
      subtitle: "Precisa de um bot customizado, automação ou sistema sob medida? Chama a gente — resposta rápida, direto com quem desenvolve.",
      emailLabel: "E-mail direto",
      whatsappLabel: "WhatsApp comercial",
      formTitle: "Envie sua mensagem",
      formName: "Seu nome",
      formEmail: "Seu e-mail",
      formMessage: "Sua mensagem",
      formSubmit: "Enviar pelo WhatsApp",
      formNote: "Sua mensagem abre direto no nosso WhatsApp — sem intermediários.",
      formIntro: "Olá, NavX! Meu nome é",
      formEmailLine: "E-mail:",
    },
    memorial: {
      label: "EM MEMÓRIA · LITO SOUSA · 1967 — 2026",
    },
    footer: {
      tagline: "Soluções inteligentes & bots inovadores.",
      rights: "© 2026 NavX Tecnologia. Todos os direitos reservados.",
    },
  },
  es: {
    nav: { home: "Inicio", bots: "Nuestros Bots", products: "Nuevos Productos", contact: "Contacto" },
    hero: {
      badge: "SISTEMAS NAVX // ONLINE",
      line1: "Soluciones",
      line2: "Inteligentes &",
      line3: "Bots Innovadores",
      subtitle:
        "Desarrollamos automatizaciones, inteligencia artificial y sistemas personalizados que llevan tu negocio al siguiente nivel.",
      ctaWhatsapp: "Habla con Nosotros por WhatsApp",
      ctaBots: "Explorar Bots",
      stats: [
        { value: "6+", label: "Bots Activos" },
        { value: "24/7", label: "Uptime" },
        { value: "<100ms", label: "Respuesta" },
      ],
      scroll: "Desliza para explorar",
    },
    marquee: ["BOTS", "AUTOMATIZACIÓN", "INTELIGENCIA ARTIFICIAL", "SISTEMAS A MEDIDA", "NAVX", "WHATSAPP API", "GAMES"],
    manifesto: {
      label: "MANIFIESTO",
      title: "Ingeniería con firma propia",
      chapters: [
        {
          num: "01",
          title: "Automatización",
          text: "Flujos de trabajo completos funcionando solos. Bots que atienden, moderan, venden y operan mientras te enfocas en lo importante.",
        },
        {
          num: "02",
          title: "Inteligencia Artificial",
          text: "Agentes de IA con respuestas naturales, memoria de contexto e integración profunda con tus herramientas de cada día.",
        },
        {
          num: "03",
          title: "Sistemas a Medida",
          text: "Del concepto al deploy: plataformas, APIs y juegos diseñados para tu necesidad exacta — sin plantillas, sin atajos.",
        },
      ],
    },
    bots: {
      label: "PORTAFOLIO",
      title: "Nuestros Bots",
      subtitle: "Asistentes autónomos y sistemas inteligentes creados con el sello de excelencia NavX.",
      byBadge: "By: NavX",
      learnMore: "Saber Más",
      addBot: "Agregar Bot",
      status: "ONLINE",
      inquiry: "¡Hola, NavX! Quiero saber más sobre el bot",
      list: [
        { id: "naty", name: "Naty", role: "MODERACIÓN", desc: "Moderadora jefa. Anti-spam, anti-links, bienvenidas personalizadas y gestión completa de grupos.", art: "naty" },
        { id: "hano", name: "Hano", role: "ENTRETENIMIENTO", desc: "Diversión garantizada: mini-juegos, economía virtual y RPG de texto dentro de tu grupo.", art: null },
        { id: "zora", name: "Zora Bot", role: "ATENCIÓN IA", desc: "Atención inteligente 24/7. Responde clientes, agenda horarios y califica leads sola.", art: null },
        { id: "momo", name: "Momo", role: "UTILIDADES", desc: "La navaja suiza de los bots: stickers, descargas, consultas y decenas de utilidades rápidas.", art: "momo" },
        { id: "madara", name: "Madara", role: "RPG / ANIME", desc: "RPG de batallas inspirado en anime. Evoluciona personajes, reta duelos y domina el ranking.", art: null },
        { id: "aizen", name: "Aizen", role: "IA AVANZADA", desc: "IA conversacional avanzada con comandos inteligentes, memoria y respuestas naturales.", art: "aizen" },
      ],
    },
    products: {
      label: "LABORATORIO",
      title: "Nuevos Productos",
      subtitle: "Los próximos lanzamientos y soluciones de tecnología que están naciendo dentro del ecosistema NavX.",
      gameTitle: "NavX Game — Proyecto en Producción",
      gameDesc:
        "Nuestro primer juego está siendo producido en este exacto momento. Una experiencia con la identidad pixel que es la cara de NavX. Mira un vistazo real del desarrollo.",
      statusProduction: "EN PRODUCCIÓN",
      statusSoon: "PRÓXIMAMENTE",
      statusLaunch: "LANZAMIENTO",
      watchNow: "Ver ahora",
      others: [
        { id: "api", name: "NavX Cloud API", desc: "Infraestructura de bots como servicio: hospeda, escala y monitorea tus bots en un solo panel.", status: "soon" },
        { id: "engine", name: "Bot Engine 2.0", desc: "La nueva generación del motor NavX: comandos por voz, IA generativa nativa y plugins de la comunidad.", status: "launch" },
      ],
    },
    contact: {
      label: "CONTACTO",
      title: "Habla con NavX",
      subtitle: "¿Necesitas un bot personalizado, automatización o un sistema a medida? Escríbenos — respuesta rápida, directo con quien desarrolla.",
      emailLabel: "Correo directo",
      whatsappLabel: "WhatsApp comercial",
      formTitle: "Envía tu mensaje",
      formName: "Tu nombre",
      formEmail: "Tu correo",
      formMessage: "Tu mensaje",
      formSubmit: "Enviar por WhatsApp",
      formNote: "Tu mensaje abre directo en nuestro WhatsApp — sin intermediarios.",
      formIntro: "¡Hola, NavX! Mi nombre es",
      formEmailLine: "Correo:",
    },
    memorial: {
      label: "EN MEMORIA · LITO SOUSA · 1967 — 2026",
    },
    footer: {
      tagline: "Soluciones inteligentes & bots innovadores.",
      rights: "© 2026 NavX Tecnología. Todos los derechos reservados.",
    },
  },
  en: {
    nav: { home: "Home", bots: "Our Bots", products: "New Products", contact: "Contact" },
    hero: {
      badge: "NAVX SYSTEMS // ONLINE",
      line1: "Intelligent",
      line2: "Solutions &",
      line3: "Innovative Bots",
      subtitle:
        "We build automations, artificial intelligence and custom systems that take your business to the next level.",
      ctaWhatsapp: "Talk to Us on WhatsApp",
      ctaBots: "Explore Bots",
      stats: [
        { value: "6+", label: "Active Bots" },
        { value: "24/7", label: "Uptime" },
        { value: "<100ms", label: "Response" },
      ],
      scroll: "Scroll to explore",
    },
    marquee: ["BOTS", "AUTOMATION", "ARTIFICIAL INTELLIGENCE", "CUSTOM SYSTEMS", "NAVX", "WHATSAPP API", "GAMES"],
    manifesto: {
      label: "MANIFESTO",
      title: "Engineering with our own signature",
      chapters: [
        {
          num: "01",
          title: "Automation",
          text: "Entire workflows running on their own. Bots that serve, moderate, sell and operate while you focus on what matters.",
        },
        {
          num: "02",
          title: "Artificial Intelligence",
          text: "AI agents with natural responses, context memory and deep integration with the tools you use every day.",
        },
        {
          num: "03",
          title: "Custom Systems",
          text: "From concept to deploy: platforms, APIs and games designed for your exact need — no templates, no shortcuts.",
        },
      ],
    },
    bots: {
      label: "PORTFOLIO",
      title: "Our Bots",
      subtitle: "Autonomous assistants and intelligent systems crafted with the NavX seal of excellence.",
      byBadge: "By: NavX",
      learnMore: "Learn More",
      addBot: "Add Bot",
      status: "ONLINE",
      inquiry: "Hi, NavX! I want to know more about the bot",
      list: [
        { id: "naty", name: "Naty", role: "MODERATION", desc: "Head moderator. Anti-spam, anti-link, custom welcomes and complete group management.", art: "naty" },
        { id: "hano", name: "Hano", role: "ENTERTAINMENT", desc: "Guaranteed fun: mini-games, virtual economy and text-based RPG inside your group.", art: null },
        { id: "zora", name: "Zora Bot", role: "AI SUPPORT", desc: "Intelligent 24/7 support. Answers customers, books appointments and qualifies leads on its own.", art: null },
        { id: "momo", name: "Momo", role: "UTILITIES", desc: "The Swiss army knife of bots: stickers, downloads, lookups and dozens of quick utilities.", art: "momo" },
        { id: "madara", name: "Madara", role: "RPG / ANIME", desc: "Anime-inspired battle RPG. Level up characters, duel rivals and dominate the server ranking.", art: null },
        { id: "aizen", name: "Aizen", role: "ADVANCED AI", desc: "Advanced conversational AI with smart commands, memory and natural responses.", art: "aizen" },
      ],
    },
    products: {
      label: "LAB",
      title: "New Products",
      subtitle: "The next releases and technology solutions being born inside the NavX ecosystem.",
      gameTitle: "NavX Game — Project in Production",
      gameDesc:
        "Our first game is being produced right now. An experience with the pixel identity that is NavX's signature. Check out a real glimpse of the development.",
      statusProduction: "IN PRODUCTION",
      statusSoon: "COMING SOON",
      statusLaunch: "NEW RELEASE",
      watchNow: "Watch now",
      others: [
        { id: "api", name: "NavX Cloud API", desc: "Bot infrastructure as a service: host, scale and monitor your bots in a single dashboard.", status: "soon" },
        { id: "engine", name: "Bot Engine 2.0", desc: "The next generation of the NavX engine: voice commands, native generative AI and community plugins.", status: "launch" },
      ],
    },
    contact: {
      label: "CONTACT",
      title: "Talk to NavX",
      subtitle: "Need a custom bot, automation or a tailor-made system? Reach out — fast answers, straight from the developers.",
      emailLabel: "Direct e-mail",
      whatsappLabel: "Business WhatsApp",
      formTitle: "Send your message",
      formName: "Your name",
      formEmail: "Your e-mail",
      formMessage: "Your message",
      formSubmit: "Send via WhatsApp",
      formNote: "Your message opens straight in our WhatsApp — no middlemen.",
      formIntro: "Hi, NavX! My name is",
      formEmailLine: "E-mail:",
    },
    memorial: {
      label: "IN MEMORIAM · LITO SOUSA · 1967 — 2026",
    },
    footer: {
      tagline: "Intelligent solutions & innovative bots.",
      rights: "© 2026 NavX Tecnologia. All rights reserved.",
    },
  },
};

const LanguageContext = createContext(null);

const detectLanguage = () => {
  const nav = (navigator.language || "pt").toLowerCase();
  if (nav.startsWith("es")) return "es";
  if (nav.startsWith("en")) return "en";
  return "pt";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("navx-lang") || detectLanguage());

  useEffect(() => {
    localStorage.setItem("navx-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
